package io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.Icons

public val Icons.LinkedServicesW500Rounded: ImageVector
    get() {
        if (_linkedServicesW500Rounded != null) {
            return _linkedServicesW500Rounded!!
        }
        _linkedServicesW500Rounded = Builder(name = "LinkedServicesW500Rounded", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 960.0f, viewportHeight = 960.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(761.91f, 363.59f)
                quadToRelative(-57.95f, 0.0f, -101.15f, -34.12f)
                quadToRelative(-43.19f, -34.12f, -58.63f, -86.6f)
                lineTo(356.15f, 242.87f)
                quadToRelative(-11.72f, 41.04f, -41.98f, 71.3f)
                quadToRelative(-30.26f, 30.26f, -71.3f, 41.98f)
                verticalLineToRelative(245.98f)
                quadToRelative(52.48f, 15.44f, 86.6f, 58.75f)
                quadToRelative(34.12f, 43.32f, 34.12f, 101.03f)
                quadToRelative(0.0f, 68.87f, -48.83f, 117.55f)
                quadToRelative(-48.83f, 48.67f, -117.39f, 48.67f)
                quadToRelative(-68.87f, 0.0f, -117.54f, -48.67f)
                quadToRelative(-48.68f, -48.68f, -48.68f, -117.55f)
                quadToRelative(0.0f, -57.71f, 34.12f, -101.03f)
                quadToRelative(34.12f, -43.31f, 86.6f, -58.75f)
                verticalLineToRelative(-245.98f)
                quadToRelative(-52.48f, -15.43f, -86.6f, -58.63f)
                quadToRelative(-34.12f, -43.19f, -34.12f, -100.39f)
                quadToRelative(0.0f, -68.63f, 48.68f, -117.3f)
                quadToRelative(48.67f, -48.68f, 117.3f, -48.68f)
                quadToRelative(57.2f, 0.0f, 100.39f, 34.12f)
                quadToRelative(43.2f, 34.12f, 58.63f, 86.6f)
                horizontalLineToRelative(245.98f)
                quadToRelative(15.44f, -52.48f, 58.63f, -86.6f)
                quadToRelative(43.2f, -34.12f, 101.15f, -34.12f)
                quadToRelative(68.87f, 0.0f, 117.55f, 48.68f)
                quadToRelative(48.67f, 48.67f, 48.67f, 117.54f)
                reflectiveQuadToRelative(-48.67f, 117.54f)
                quadToRelative(-48.68f, 48.68f, -117.55f, 48.68f)
                close()
                moveTo(197.13f, 837.13f)
                quadToRelative(31.13f, 0.0f, 53.29f, -22.49f)
                quadToRelative(22.17f, -22.5f, 22.17f, -52.49f)
                quadToRelative(0.0f, -31.02f, -22.15f, -53.12f)
                quadToRelative(-22.14f, -22.1f, -53.24f, -22.1f)
                quadToRelative(-30.16f, 0.0f, -52.6f, 22.1f)
                quadToRelative(-22.45f, 22.1f, -22.45f, 53.12f)
                quadToRelative(0.0f, 30.09f, 22.5f, 52.53f)
                quadToRelative(22.49f, 22.45f, 52.48f, 22.45f)
                close()
                moveTo(197.13f, 272.59f)
                quadToRelative(31.13f, 0.0f, 53.29f, -22.17f)
                quadToRelative(22.17f, -22.16f, 22.17f, -53.29f)
                quadToRelative(0.0f, -30.93f, -22.15f, -52.95f)
                quadToRelative(-22.14f, -22.03f, -53.24f, -22.03f)
                quadToRelative(-30.16f, 0.0f, -52.6f, 22.06f)
                quadToRelative(-22.45f, 22.06f, -22.45f, 53.03f)
                quadToRelative(0.0f, 30.98f, 22.5f, 53.16f)
                quadToRelative(22.49f, 22.19f, 52.48f, 22.19f)
                close()
                moveTo(762.51f, 928.61f)
                quadToRelative(-68.75f, 0.0f, -117.54f, -48.56f)
                quadToRelative(-48.8f, -48.55f, -48.8f, -117.42f)
                reflectiveQuadToRelative(48.8f, -117.66f)
                quadToRelative(48.79f, -48.8f, 117.54f, -48.8f)
                reflectiveQuadToRelative(117.42f, 48.8f)
                quadToRelative(48.68f, 48.79f, 48.68f, 117.66f)
                reflectiveQuadTo(879.93f, 880.05f)
                quadToRelative(-48.67f, 48.56f, -117.42f, 48.56f)
                close()
                moveTo(762.63f, 837.61f)
                quadToRelative(30.93f, 0.0f, 52.95f, -22.49f)
                quadToRelative(22.03f, -22.5f, 22.03f, -52.49f)
                quadToRelative(0.0f, -31.13f, -22.06f, -53.29f)
                quadToRelative(-22.06f, -22.17f, -53.03f, -22.17f)
                quadToRelative(-30.98f, 0.0f, -53.16f, 22.15f)
                quadToRelative(-22.19f, 22.14f, -22.19f, 53.24f)
                quadToRelative(0.0f, 30.16f, 22.17f, 52.6f)
                quadToRelative(22.16f, 22.45f, 53.29f, 22.45f)
                close()
                moveTo(762.15f, 272.59f)
                quadToRelative(30.93f, 0.0f, 52.96f, -22.17f)
                quadToRelative(22.02f, -22.16f, 22.02f, -53.29f)
                quadToRelative(0.0f, -30.93f, -22.06f, -52.95f)
                quadToRelative(-22.06f, -22.03f, -53.03f, -22.03f)
                quadToRelative(-30.97f, 0.0f, -53.16f, 22.06f)
                quadToRelative(-22.18f, 22.06f, -22.18f, 53.03f)
                quadToRelative(0.0f, 30.98f, 22.16f, 53.16f)
                quadToRelative(22.17f, 22.19f, 53.29f, 22.19f)
                close()
                moveTo(197.37f, 761.91f)
                close()
                moveTo(197.37f, 197.37f)
                close()
                moveTo(762.39f, 762.39f)
                close()
                moveTo(761.91f, 197.37f)
                close()
            }
        }
        .build()
        return _linkedServicesW500Rounded!!
    }

private var _linkedServicesW500Rounded: ImageVector? = null
